export const themeColor = "#160224ff";

// --- Navigation Data ---
const aboutItems = [
  { key: "who", label: "Who we are", path: "/about-us" },
  { key: "careers", label: "Careers", path: "/careers" },
  { key: "contact", label: "Contact", path: "/contact" },
];

const sportsMenuItems = [
  { key: "football", label: "Football", path: "/football" },
  { key: "cricket", label: "Cricket", path: "/cricket" },
  { key: "martial-arts", label: "Jiu Jitsu", path: "/jiujitsu" },
];

const eventsItems = [
  {
    key: "upcoming",
    label: "Upcoming Events Calendar",
    path: "/events/calendar"  // This now points to the specific coming soon page
  },
  { 
    key: "host", 
    label: "Host an Event with Us", 
    path: "/events/host"  // This now points to the specific coming soon page
  },
  { key: "workshops", label: "Workshops & Seminars", path: "/seminars" },
];

const mediaItems = [
  { key: "gallery", label: "Gallery", path: "/coming-soon/gallery" },
  { 
    key: "video", 
    label: "Video Hub", 
    path: "/coming-soon/video-hub"  // Specific coming soon page
  },
  { 
    key: "magzine", 
    label: "YNO Magazine", 
    path: "/media/magzine"  // Specific coming soon page
  },
  { 
    key: "announcements", 
    label: "Announcements & News", 
    path: "/coming-soon/announcements-news"  // Coming soon page for Announcements & News
  },
  { 
    key: "press", 
    label: "Press Releases", 
    path: "/media/press-releases"  // Specific coming soon page
  },
];

const getInvolvedItems = [
  { key: "player", label: "Join as a Player", path: "/get-involved/player" },
  { key: "volunteer", label: "Join as Volunteer", path: "/volunteer" },
  { key: "partner", label: "Partner with Us", path: "/partner-with-us" },
  { key: "sponsor", label: "Sponsor an Event", path: "/sponsor-event" },
];

const productsItems = [
  { 
    key: "shop", 
    label: "Shop", 
    path: "/coming-soon/shop"  // Coming soon page for Shop
  },
  { 
    key: "app", 
    label: "App", 
    path: "/coming-soon/app"  // Coming soon page for App
  },
];

export const mainNavStructure = [
  { key: "about", label: "About Us", items: aboutItems, pathPrefix: "/about" },
  {
    key: "sports",
    label: "Sports",
    items: sportsMenuItems,
    pathPrefix: "/sports",
  },
  { key: "events", label: "Events", items: eventsItems, pathPrefix: "/events" },
  { key: "media", label: "Media", items: mediaItems, pathPrefix: "/media" },
  {
    key: "get-involved",
    label: "Get Involved",
    items: getInvolvedItems,
    pathPrefix: "/get-involved",
  },
  { 
    key: "stats", 
    label: "Stats Zone", 
    path: "/coming-soon/stats-zone"  // Coming soon page for Stats Zone
  },
  {
    key: "products",
    label: "Products",
    items: productsItems,
    pathPrefix: "/products",
  },
];